export default __webpack_public_path__ + "static/media/HD file.badf43b9.png";